// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1VDKO","resendInfoText":"OnGoingPaymentBox_resendInfoText__1DAgB"};